// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4x-2";
export var blackBorderOnHover = "_4x-7";
export var cell = "_4x-6";
export var cellContainer = "_4x-3";
export var checked = "_4x-8";
export var disabled = "_4x-5";
export var featuredIconCellContainer = "_4x-9";
export var featuredIconTextContainer = "_4x-b";
export var featuredIconWrapper = "_4x-a";
export var noBorder = "_4x-c";
export var orangeSelectedRow = "_eb-3";
export var overflowableText = "_4x-0";
export var overflowableTextContainer = "_4x-1";
export var row = "_4z-0";
export var rowCheckboxCell = "_4x-4";
export var selectableTable = "_eb-2";